import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Card, Descriptions,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicleDrivingTime } from '../../../../store/actions';
import { getVehicleDrivingTimes } from '../../../../store/selectors';
import getDriverInfoConfig from './getDriverInfoConfig';

const DriverInfoModal = ({ visible, onClose, vehicle }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const drivingTimesState = useSelector(getVehicleDrivingTimes);

  useEffect(() => {
    if (visible && vehicle) {
      dispatch(fetchVehicleDrivingTime(vehicle.vehicleId));
    }
  }, [visible, vehicle, dispatch]);

  if (!vehicle) {
    return null;
  }

  const driverInfoKey = 'VEHICLE.DRIVER_INFO';

  const driverInfoConfig = getDriverInfoConfig(vehicle, t, drivingTimesState);

  return driverInfoConfig.length > 0 && (
    <Modal
      title={(
        <h3>
          {t(`${driverInfoKey}.MODAL.TITLE`, { licensePlateNumber: vehicle.licencePlateNumber })}
        </h3>
      )}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={650}
    >
      {driverInfoConfig.map((driverConfig, index) => (
        <Card
          title={`${t(`${driverInfoKey}.INFORMATION.TITLE`)}
          ${driverInfoConfig.length > 1 ? ` - ${driverConfig.driverId}` : ''}`}
          style={{ marginBottom: index < driverInfoConfig.length - 1 ? '16px' : '0' }}
          key={`driver-info-${driverConfig.driverId || index}`}
        >
          <Descriptions bordered size="small" column={1}>
            {driverConfig.config.map((item) => (
              <Descriptions.Item label={t(item.title)} key={item.title}>
                {item.loading() ? t('LOADING') : item.renderDetail()}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Card>
      ))}
    </Modal>
  );
};

DriverInfoModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vehicle: PropTypes.shape({
    vehicleId: PropTypes.string,
    licencePlateNumber: PropTypes.string,
  }),
};

DriverInfoModal.defaultProps = {
  vehicle: null,
};

export default DriverInfoModal;
